module.exports = __webpack_public_path__ + "static/img/SearchDetailBorn2.9a68585.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailBorn2.png
// module id = 710
// module chunks = 0